(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sticky-add-to-cart"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mm-sticky-atc')) {
    class MmStickyAtc extends HTMLElement {
      connectedCallback() {
        this.submitButton = this.querySelector('[data-mm-sticky-atc-submit]');
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.isIntersecting = true;
        this.onSubmit = () => {
          const section = this.closest('.product-information');
          const formButton = section?.querySelector('product-form-component button[name="add"]');
          if (formButton instanceof HTMLButtonElement && !formButton.disabled) formButton.click();
        };
        this.submitButton?.addEventListener('click', this.onSubmit);
        this.onViewportChange = () => this.updateVisibility();
        this.mobileQuery.addEventListener('change', this.onViewportChange);

        const section = this.closest('.product-information');
        const target = section?.querySelector('.product-form-buttons');
        if (target && 'IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              this.isIntersecting = entries.some((entry) => entry.isIntersecting);
              this.updateVisibility();
            },
            { threshold: 0.15 }
          );
          this.observer.observe(target);
        } else {
          this.isIntersecting = false;
          this.updateVisibility();
        }
      }

      updateVisibility() {
        const show = this.mobileQuery.matches && !this.isIntersecting;
        this.hidden = !show;
        document.body.classList.toggle('mm-sticky-atc-active', show);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.submitButton?.removeEventListener('click', this.onSubmit);
        this.mobileQuery?.removeEventListener('change', this.onViewportChange);
        if (!document.querySelector('mm-sticky-atc:not([hidden])')) {
          document.body.classList.remove('mm-sticky-atc-active');
        }
      }
    }

    customElements.define('mm-sticky-atc', MmStickyAtc);
  }
  } catch(e) { console.error(e); }
})();

})();
